import { getLastNDaysFromToday } from "./fixDateRangeCondition";

export const appendAttendanceSettingsTimeDimension = (item, attendanceSetting) => {
    if (item?.chartConfig.schema === 'Employee') {
        const reportDays = attendanceSetting.reportDays || 60;
        const routeDateTimeDimension = {
            dimension: 'Employee.date_created',
            dateRange: [getLastNDaysFromToday(reportDays).nDaysAgoFormatted, getLastNDaysFromToday(reportDays).nowFormatted]
        }
        if (!item?.chartQuery?.timeDimensions?.length) {
            if (Array.isArray(item?.chartQuery?.timeDimensions)) {
                item.chartQuery.timeDimensions.push(routeDateTimeDimension);
            } else {
                item.chartQuery.timeDimensions = [routeDateTimeDimension];
            }
            item.attendanceTimeDimension = true;
        }
        if (item?.chartDetailQuery?.timeDimensions?.length === 0) {
            item.chartDetailQuery.timeDimensions.push(routeDateTimeDimension);
            item.attendanceTimeDimension = true;
        }
    }
    return item;
}

export const removeAttendanceSettingsTimeDimension = (item) => {
    if (item?.chartConfig.schema === 'Employee' && item.attendanceTimeDimension) {
        if (item?.chartQuery?.timeDimensions?.length === 1) {
            item.chartQuery.timeDimensions = [];
        }
        if (item?.chartDetailQuery?.timeDimensions?.length === 1) {
            item.chartDetailQuery.timeDimensions = [];
        }
        delete item.attendanceTimeDimension;
    }
    return item;
}

export const removeDefaultAttendanceTimeDimension = (chartQuery, isRemove) => {
    if (isRemove && chartQuery?.timeDimensions) {
        const tempTimeDimensions = JSON.parse(JSON.stringify(chartQuery?.timeDimensions));
        chartQuery.timeDimensions = tempTimeDimensions.filter(item => {
            return !(item?.dateRange?.length === 2 && item?.dimension === 'Employee.date_created' && !item.granularity);
        });
    }
    return chartQuery;
}